import React from 'react';
import { LuFileText } from 'react-icons/lu';
import { useVisitTopicsData } from '../../../hooks/useVisitTopicsData.js';
import Alert from '../../ui/Alert';
import Skeleton from '../../ui/Skeleton';
import { Modal } from '../../ui/Modal';
import { asV, parseVersion, shortVersion, versionLabel } from './topicsVersion.js';

const PROMPT_PARTS = [
  ['split', 'Découpage en visites (GPT Luna)'],
  ['write', 'Rédaction des topics (GPT Luna)'],
  ['propose', 'Proposition d\'un topic (GPT Luna)'],
];
const DECISION_PARTS = [
  ['input', 'Cadre de l\'entrée'],
  ['topic', 'Question posée pour chaque topic'],
  ['other', 'Question « autre chose »'],
  ['proposal', 'Réutilisation d\'une proposition'],
  ['store', 'Choix du magasin'],
];

const PromptText = ({ title, text }) => (
  <section>
    <h3 className="mb-1.5 text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">{title}</h3>
    <pre className="whitespace-pre-wrap break-words rounded-lg bg-gray-50 p-3 font-mono text-xs leading-relaxed text-gray-800 dark:bg-night-900 dark:text-gray-100">{text}</pre>
  </section>
);

const VisitTopicsPromptsModal = ({ fetchWithAuth, version, onClose }) => {
  const { status, data: prompts } = useVisitTopicsData(fetchWithAuth, '/prompts');
  const v = parseVersion(version);
  const label = v && versionLabel(v);
  const topics = prompts?.topics.find((p) => p.version === v?.prompt)?.prompt;
  const decisions = prompts?.decisions.find((p) => p.version === v?.decisions)?.prompt;
  return (
    <Modal
      isOpen
      onClose={onClose}
      size="lg"
      icon={LuFileText}
      title={v ? shortVersion(version) : version}
      subtitle="Les textes envoyés à GPT Luna et à l'API Decisions pour ce post. {{catalog}} et les {champs} sont remplis à l'exécution."
    >
      <div className="space-y-5">
        {status === 'loading' && <Skeleton className="h-64" />}
        {status === 'error' && <Alert tone="danger">Impossible de charger les prompts.</Alert>}
        {status === 'ready' && !topics && <Alert tone="warning">Le prompt {v ? asV(v.prompt) : version} n'existe plus dans le code.</Alert>}
        {topics && (
          <>
            <PromptText title={`${label.prompt} (GPT Luna) · Rôle commun aux trois appels`} text={topics.role} />
            {PROMPT_PARTS.map(([key, title]) => <PromptText key={key} title={`${label.prompt} · ${title}`} text={topics[key]} />)}
          </>
        )}
        {decisions && DECISION_PARTS.map(([key, title]) => <PromptText key={key} title={`${label.questions} (API Decisions) · ${title}`} text={decisions[key]} />)}
      </div>
    </Modal>
  );
};

export default VisitTopicsPromptsModal;
